export default {
  slug: "dotpeek",
  code: "DP",
  label: "dotPeek",
  krakenDir: "dotPeek",
  thumbnailColor: "#07C3F2",
  logoFamily: "jb",
};
